import { getDefaultMessage } from './utils';
import * as actionTypes from './actionTypes';

export const enqueueNotification = notification => ({
  type: actionTypes.ENQUEUE_NOTIFICATION_TOAST,
  payload: {
    key: Math.random(),
    message: getDefaultMessage(notification.type),
    ...notification,
  },
});

export const dequeueNotification = () => ({
  type: actionTypes.DEQUEUE_NOTIFICATION_TOAST,
});

export const createNotification = ({ key = Math.random(), ...notification }) => ({
  type: actionTypes.ADD_TOAST_NOTIFICATION,
  payload: {
    key,
    message: getDefaultMessage(notification.type),
    ...notification,
  },
});
